import React from 'react';
import Battery0BarOutlinedIcon from '@mui/icons-material/Battery0BarOutlined';
import Battery1BarOutlinedIcon from '@mui/icons-material/Battery1BarOutlined';
import Battery2BarOutlinedIcon from '@mui/icons-material/Battery2BarOutlined';
import Battery3BarOutlinedIcon from '@mui/icons-material/Battery3BarOutlined';
import Battery4BarOutlinedIcon from '@mui/icons-material/Battery4BarOutlined';
import Battery5BarOutlinedIcon from '@mui/icons-material/Battery5BarOutlined';
import Battery6BarOutlinedIcon from '@mui/icons-material/Battery6BarOutlined';
import BatteryFullOutlinedIcon from '@mui/icons-material/BatteryFullOutlined';
import ElectricalServicesOutlinedIcon from '@mui/icons-material/ElectricalServicesOutlined';

const BatteryIndicator = ({level=100, batteryOrPlug='battery', sx={}, variant='filled', clickable, onClick}) => {
    sx = {
        ...sx,
        transform: 'rotate(90deg)', 
    }
    if(variant === 'outlined') {
        sx['backgroundColor'] = 'white';
    }

    if(batteryOrPlug === 'plug') {
        return (
            <ElectricalServicesOutlinedIcon sx={sx} />
        );
    } else {
        if(level <= 5) { return <Battery0BarOutlinedIcon color={'error'} sx={sx} />}
        else if(level <= 15) { return <Battery1BarOutlinedIcon color={'error'} sx={sx} />}
        else if(level <= 30) { return <Battery2BarOutlinedIcon sx={sx} />}
        else if(level <= 40) { return <Battery3BarOutlinedIcon sx={sx} />}
        else if(level <= 60) { return <Battery4BarOutlinedIcon sx={sx} />}
        else if(level <= 80) { return <Battery5BarOutlinedIcon sx={sx} />}
        else if(level <= 90) { return <Battery6BarOutlinedIcon sx={sx} />}
        else { return <BatteryFullOutlinedIcon sx={sx} /> }
    }
};

export default BatteryIndicator;